import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Text4, Text6 } from "@churchofjesuschrist/eden-text";
import { spacing4, spacing16 } from "@churchofjesuschrist/eden-style-constants";
const Container = styled.div.withConfig({
  componentId: "sc-169bs0j-0"
})(["max-width:512px;max-height:120px;padding:", " 0;"], spacing16);
const CaptionText = styled.div.withConfig({
  componentId: "sc-169bs0j-1"
})(["padding-block-end:", ";"], spacing16);
const Attribution = styled.div.withConfig({
  componentId: "sc-169bs0j-2"
})([""]);
const ModalTitle = styled.strong.withConfig({
  componentId: "sc-169bs0j-3"
})(["padding-inline-end:", ";"], spacing4);

const Caption = _ref => {
  let {
    title,
    caption,
    attribution
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, null, caption && /*#__PURE__*/React.createElement(CaptionText, null, /*#__PURE__*/React.createElement(Text4, {
    inverted: true
  }, title && /*#__PURE__*/React.createElement(ModalTitle, null, title), caption)), attribution && /*#__PURE__*/React.createElement(Attribution, null, /*#__PURE__*/React.createElement(Text6, {
    inverted: true
  }, attribution)));
};

Caption.propTypes = {
  /** Media Title */
  title: PropTypes.string,

  /** Media Caption */
  caption: PropTypes.node,

  /** Media Attribution */
  attribution: PropTypes.node
};
export default Caption;